import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Div from '@hellodarwin/core/lib/components/common/div';
import Typography from '@hellodarwin/core/lib/components/common/typography';
import { useTheme } from 'styled-components';
const RawDataFallback = ({ data, label }) => {
    const theme = useTheme();
    return (_jsxs(Div, { style: { marginTop: theme.spacing.sm }, children: [label && (_jsx(Typography, { elementTheme: "caption", color: theme.colors.grey_3, style: { marginBottom: theme.spacing.xs }, children: label })), _jsx("pre", { style: {
                    fontFamily: 'monospace',
                    fontSize: theme.fonts.overline,
                    backgroundColor: theme.colors.grey_5,
                    padding: theme.spacing.sm,
                    borderRadius: theme.border_radius.sm,
                    overflow: 'auto',
                    maxHeight: 400,
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                }, children: typeof data === 'string' ? data : JSON.stringify(data, null, 2) })] }));
};
export default RawDataFallback;
